import actionListTable from "./actionListTable.component";

const actionListTableModule = angular
  .module("app.components.actionListTable", [])
  .component("actionListTable", actionListTable);

export default actionListTableModule;



// WEBPACK FOOTER //
// ./src/components/actionListTable/actionListTable.module.js